import type { SearchFilterV2Store } from '@repo/common/components/Filter/store';
import { SearchFilterV2StoreContext } from '@repo/common/components/Filter/store';
import { ReactFlowProvider } from '@xyflow/react';
import type { ReactNode } from 'react';
import type LineageFlowStore from '../../store/LineageFlowStore';
import type LineageFlowUIStore from '../../store/LineageFlowUIStore';
import { LineageFlowContext, LineageFlowUIContext } from './LineageFlowContext';

interface LineageFlowProviderProps {
	filterStore: SearchFilterV2Store;
	children: ReactNode;
	lineageFlowStore: LineageFlowStore;
	lineageFlowUIStore: LineageFlowUIStore;
}

function LineageFlowProvider({
	filterStore,
	children,
	lineageFlowStore,
	lineageFlowUIStore,
}: LineageFlowProviderProps) {
	return (
		<SearchFilterV2StoreContext.Provider value={filterStore}>
			<LineageFlowContext.Provider value={lineageFlowStore}>
				<LineageFlowUIContext.Provider value={lineageFlowUIStore}>
					<ReactFlowProvider>{children}</ReactFlowProvider>
				</LineageFlowUIContext.Provider>
			</LineageFlowContext.Provider>
		</SearchFilterV2StoreContext.Provider>
	);
}

export default LineageFlowProvider;
